import { render, staticRenderFns } from "./root-files.vue?vue&type=template&id=a98608e4"
import script from "./root-files.vue?vue&type=script&lang=js"
export * from "./root-files.vue?vue&type=script&lang=js"
import style0 from "./root-files.vue?vue&type=style&index=0&id=a98608e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports